var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "basket-list-item py-3" }, [
    _c(
      "div",
      { staticClass: "basket-item component-loading with-icon d-flex" },
      [
        _c("div", { staticClass: "image-container" }, [
          _c("a", { attrs: { href: _vm._f("itemURL")(_vm.wishListItem) } }, [
            _vm.image
              ? _c("img", {
                  staticClass: "d-block mw-100 mh-100",
                  attrs: {
                    src: _vm.image,
                    title: _vm._f("itemName")(_vm.wishListItem),
                  },
                })
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "meta-container-wrapper" }, [
          _c("div", { staticClass: "meta-container-wrapper-inner mb-2" }, [
            _c("div", { staticClass: "meta-container" }, [
              _c("div", { staticClass: "position-relative w-100" }, [
                _c(
                  "a",
                  { attrs: { href: _vm._f("itemURL")(_vm.wishListItem) } },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "basket-item-name text-primary text-appearance small font-weight-bold text-break",
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t" +
                            _vm._s(_vm.wishListItem.texts.name2) +
                            "\n\t\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "basket-item-description" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t\t" +
                          _vm._s(_vm.wishListItem.texts.name3) +
                          "\n\t\t\t\t\t\t\t"
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "basket-item-bottom" }, [
                  _c("div", { staticClass: "basket-item-number" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t\t" +
                        _vm._s(
                          _vm.$translate(
                            "HoferAntikschmuck::Template.singleItemObjectNr"
                          )
                        ) +
                        ": " +
                        _vm._s(_vm.wishListItem.variation.number) +
                        "\n\t\t\t\t\t\t\t"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "basket-item-delete",
                      attrs: { "data-testing": "remove-wlist-item" },
                      on: {
                        click: function ($event) {
                          return _vm.removeItem()
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "16",
                            height: "16",
                            fill: "currentColor",
                          },
                        },
                        [_c("use", { attrs: { "xlink:href": "#cancel" } })]
                      ),
                      _vm._v(
                        "\n\t\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$translate("Ceres::Template.basketDelete")
                          ) +
                          "\n\t\t\t\t\t\t\t"
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basket-item-container-right" }, [
              _c(
                "div",
                { staticClass: "basket-item-price-box" },
                [
                  _c("div", { staticClass: "item-total-price" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t" +
                        _vm._s(
                          _vm._f("currency")(_vm.quantity * _vm.unitPrice)
                        ) +
                        "\n\t\t\t\t\t\t"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("add-to-basket", {
                    attrs: {
                      "variation-id": _vm.wishListItem.variation.id,
                      "is-salable":
                        !!_vm.wishListItem.filter &&
                        _vm.wishListItem.filter.isSalable,
                      "has-children":
                        !!_vm.wishListItem.filter &&
                        _vm.wishListItem.filter.hasActiveChildren,
                      "interval-quantity":
                        _vm.wishListItem.variation.intervalOrderQuantity || 1,
                      "minimum-quantity":
                        _vm.wishListItem.variation.minimumOrderQuantity,
                      "maximum-quantity":
                        !!_vm.wishListItem.variation.maximumOrderQuantity &&
                        _vm.wishListItem.variation.maximumOrderQuantity > 0
                          ? _vm.wishListItem.variation.maximumOrderQuantity
                          : null,
                      "order-properties": _vm.wishListItem.properties.filter(
                        (prop) => prop.property.isOderProperty
                      ),
                      "has-order-properties":
                        _vm.wishListItem.hasOrderProperties,
                      "has-required-order-property":
                        _vm.wishListItem.hasRequiredOrderProperty,
                      "use-large-scale": false,
                      "show-quantity": false,
                      "item-url": _vm._f("itemURL")(_vm.wishListItem),
                      "has-price": _vm._f("hasItemDefaultPrice")(
                        _vm.wishListItem
                      ),
                      "is-wish-list": true,
                      "prop-quantity": _vm.quantity,
                      "item-type": _vm.wishListItem.item.itemType,
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }